export enum CurrencyCode {
  Euro = 'EUR',
  PoundSterling = 'GBP',
}
